<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title title">Edit User Role</p>
    </header>
    <div>
      <section class="modal-card-body">
       <b-field label="Role">
            <b-select v-model="itemData.role" placeholder="Select a character" expanded>
                <option value="manager">Manager</option>
                <option value="basic">Basic</option>
            </b-select>
        </b-field>
        <b-field label="Address">
          <b-input v-model="itemData.address" type="text">
          </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button cancel" type="button" @click="$parent.close()">
          Cancel
        </button>
        <button class="button btn">Save</button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TodoEditModal',
  props: [
    'selectedId',
    'action',
    'userData'
  ],
  data() {
    return {
      isEditModalActive: false,
      itemData: {}
    };
  },
  computed: {
    ...mapGetters(['getLoggedUser', 'getStatus'])
  },
  async mounted() {
    await this.$nextTick(() => {
      if (this.action && this.action.toLowerCase() === 'edit') {
        this.itemData = this.userData;
        this.itemData.role = this.userData.role;
        this.itemData.address = this.userData.address;
      }
    });
  }
};
</script>

<style scoped>
.modal-card {
  width: 30vw !important;
}
.field {
  display: flex;
  flex-direction: column;
}
.old {
  margin-bottom: 30px !important;
}
.title {
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 26px;
  color: #000000;
}
.label {
  margin-bottom: 20px;
  width: 100% !important;
}
.control{
  width: 100%;
}
.modal-card-body {
  padding: 1.5rem 40px;
}
.modal-card-foot {
  padding: 20px 40px;
  display: flex;
  justify-content: flex-end;
}
.error {
  color: red;
  font-size: 14px;
}
.cancel {
  background: transparent;
  border: none;
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 13px;
  color: #5051DB;
}
.btn {
  background: #3887F6;
  color: #ffffff;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 13px;
  padding: 20px 40px;
}
@media screen and (max-width: 768px) {
  .modal-card {
    width: 90vw !important;
  }
}
</style>
